import * as React from "react";
import styled from "styled-components";
import * as OrdersStore from "../../store/OrdersReducer";
import * as actions from "../Actions/ordersActions";
import { Row, Col } from "react-grid-system";
import { BackIcon, DownloadIcon } from "../../svg";
import Loader from "../Loader";
import Button from "../Button";
import Box from "../Box";
import { formatDate } from "../Utils/actions";
// @ts-ignore
import { RouteComponentProps } from "react-router";

// At runtime, Redux will merge together...
type OrdersProps = OrdersStore.OrdersState & // ... state we've requested from the Redux store
  typeof OrdersStore.actionCreators & // ... plus action creators we've requested
  RouteComponentProps<{ location: any; orderId: any }>; // ... plus incoming routing parameters

class OrderDetails extends React.Component<OrdersProps> {
  //multiple select?
  //POC action
  state = {
    orderDetails: {
      id: {},
    },
    closeModal: undefined,
    selectedRow: undefined,
    selectedRowIdx: {},
  };

  constructor(props) {
    super(props);
  }

  downloadOrder = (orderId) => {
    this.props.downloadOrder(orderId);
  };

  componentDidMount() {
    let ref = this;
    const selectedOrderId = this.props.match.params.orderId;
    let callback = (response) => {
      ref.setState({
        selectedRow: response,
        shouldRender: false,
      });
    };
    let error = () => {
      ref.setState({
        selectedRow: {},
        shouldRender: false,
      });
    };
    actions.getOrderDetails(selectedOrderId, callback, error);
  }

  resetBtnState() {
    let buttons = document.getElementsByTagName("button");
    for (let i = 0; i < buttons.length; i++) {
      buttons[i].disabled = false;
    }
  }

  toggleMapBtnState = (state) => {
    var createDisabled = this.state.selectedRow ? false : true,
      createBtn = document.getElementById("create-map-btn");
    if (createBtn) {
      (createBtn as HTMLInputElement).disabled = state ? state : createDisabled;
    }
  };

  navigateBack = (event) => {
    this.props.history.push("/orders");
  };

  public render() {
    const Detail = styled.div`
      position: relative;
    `;

    const Buttons = styled.div`
      margin-bottom: 30px;
      display: flex;
      justify-content: space-between;
    `;

    Detail.Row = styled.div`
      border-bottom: 1px solid ${({ theme }) => theme.colors.border};
      padding: 10px 15px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    `;

    const Label = styled.h6`
      font-size: 15px;
      font-weight: 500;
      width: 40%;
      line-height: 1.3;
      color: ${({ theme }) => theme.colors.dark};
    `;

    const Value = styled.div`
      font-size: 14px;
      font-weight: 400;
      width: 60%;
      text-align: right;
    `;

    const NoResults = styled.div`
      text-align: center;
      width: 100%;
      display: flex;
      justify-content: center;
      margin-top: 30px;
    `;

    const Alert = styled.div`
      display: inline-block;
      background: ${({ theme }) => theme.colors.danger};
      color: #fff;
      border-radius: 3px;
      padding: 5px 10px;
    `;

    const Table = styled.table`
      text-align: left;
      width: 100%;

      thead th {
        font-size: 14px;
        font-weight: 500;
        color: ${({ theme }) => theme.colors.dark};
      }

      &:not(.table-bordered) thead td,
      &:not(.table-bordered) thead th {
        border-top: 0;
      }

      td,
      th {
        padding: 0.75rem;
        vertical-align: top;
        border-top: 1px solid #ebedf2;
      }

      tbody tr:nth-of-type(odd) {
        background-color: #f7f8fa;
      }
    `;
    const { isLoading } = this.props;
    let hermesOrder = this.state.selectedRow ? this.state.selectedRow : "",
      orderExists = hermesOrder ? true : false,
      rowExists = hermesOrder ? true : false,
      hermesOrderDetails = hermesOrder["orderDetailsInfo"]
        ? hermesOrder["orderDetailsInfo"]
        : "",
      missingSkuMapping = hermesOrder["missingSkuMapping"],
      missingPocMapping = hermesOrder["missingPocMapping"],
      hermesOrderId = orderExists ? hermesOrder["orderId"] : "",
      hermesOrderIsSeen = orderExists
        ? hermesOrder["isSeen"]
          ? "True"
          : "False"
        : "",
      distributorCustomer = orderExists
        ? hermesOrder["distributorCustomer"]
          ? hermesOrder["distributorCustomer"]
          : ""
        : "",
      distributorName = orderExists ? hermesOrder["distributorName"] : "",
      depotName = orderExists ? hermesOrder["depotName"] : "",
      orderDate = orderExists ? hermesOrder["orderDate"] : "",
      hermesPoc = orderExists ? hermesOrder["hermesPoc"] : "";
    return isLoading ? (
      <Loader isLoading={true} />
    ) : (
      <div>
        <Buttons>
          <Button
            icon={BackIcon}
            size="large"
            variant="outlined"
            onClick={this.navigateBack}
          >
            Back
          </Button>
          <Button
            icon={DownloadIcon}
            size="large"
            onClick={() => this.downloadOrder(hermesOrder.id)}
          >
            XML
          </Button>
        </Buttons>

        <Box hasMargin hasContentGutter title="Order Details">
          <Detail>
            <Detail.Row>
              <Label>Order Number</Label>
              <Value>{orderExists ? hermesOrderId : ""}</Value>
            </Detail.Row>

            <Detail.Row>
              <Label>Is Seen</Label>
              <Value>{orderExists ? hermesOrderIsSeen : ""}</Value>
            </Detail.Row>

            <Detail.Row>
              <Label>Distributor</Label>
              <Value>{rowExists ? hermesOrder["distributorName"] : ""}</Value>
            </Detail.Row>

            <Detail.Row>
              <Label>Has Missing Mapping</Label>
              <Value>
                {orderExists
                  ? missingSkuMapping || missingPocMapping
                    ? "True"
                    : "False"
                  : ""}
              </Value>
            </Detail.Row>

            <Detail.Row>
              <Label>Depot</Label>
              <Value>{orderExists ? depotName : ""}</Value>
            </Detail.Row>

            <Detail.Row>
              <Label>Order Date</Label>
              <Value> {orderExists ? formatDate(orderDate) : ""}</Value>
            </Detail.Row>
          </Detail>
        </Box>

        <Row>
          <Col xs={12} sm={6}>
            <Box hasMargin hasContentGutter title="POC Hermes">
              <Detail>
                <Detail.Row>
                  <Label>Име</Label>
                  <Value>{hermesPoc["name"]}</Value>
                </Detail.Row>

                <Detail.Row>
                  <Label>ЕИК</Label>
                  <Value>
                    {hermesPoc["customer"]
                      ? hermesPoc["customer"]["fiscalCode"]
                      : ""}
                  </Value>
                </Detail.Row>

                <Detail.Row>
                  <Label>Адрес</Label>
                  <Value>{hermesPoc["address"]}</Value>
                </Detail.Row>
              </Detail>
              {missingPocMapping ? (
                <NoResults>
                  <Alert>Missing mapping!</Alert>
                </NoResults>
              ) : (
                ""
              )}
            </Box>
          </Col>

          <Col xs={12} sm={6}>
            <Box hasMargin hasContentGutter title="POC Distributor">
              <Detail>
                <Detail.Row>
                  <Label>Име</Label>
                  <Value>{distributorCustomer["name"]}</Value>
                </Detail.Row>

                <Detail.Row>
                  <Label>ЕИК</Label>
                  <Value>{distributorCustomer["vat"]}</Value>
                </Detail.Row>

                <Detail.Row>
                  <Label>Адрес</Label>
                  <Value>{distributorCustomer["addressOfDispatching"]}</Value>
                </Detail.Row>
              </Detail>

              {missingPocMapping ? (
                <NoResults>
                  <Alert>Missing mapping!</Alert>
                </NoResults>
              ) : (
                ""
              )}
            </Box>
          </Col>
        </Row>

        <Box hasMargin hasContentGutter title="Order Items">
          <Table>
            <thead>
              <tr>
                <th>Hermes SKU КОД</th>
                <th>Hermes SKU ИМЕ</th>
                <th>Distributor SKU КОД</th>
                <th>Distributor SKU ИМЕ</th>
                <th>Свободно</th>
              </tr>
            </thead>

            <tbody>
              {hermesOrderDetails
                ? hermesOrderDetails.map((orderItem, id) => {
                    return (
                      <tr>
                        <td>{orderItem["skuCode"]}</td>
                        <td>{orderItem["skuName"]}</td>
                        <td>{orderItem["productCode"]}</td>
                        <td>{orderItem["productName"]}</td>
                        <td>{orderItem["isFree"] ? "True" : "False"}</td>
                      </tr>
                    );
                  })
                : ""}
            </tbody>
          </Table>
          {missingSkuMapping ? (
            <NoResults>
              <Alert>Missing mapping!</Alert>
            </NoResults>
          ) : (
            ""
          )}
        </Box>
      </div>
    );
  }
  /*
	  {hermesOrderDetails ? hermesOrderDetails.map((orderItem, id) => {
		return (<tr>{Object.keys(orderItem).map(function (value, idx) {
			return <td>{orderItem[value]}</td>
		})}</tr>)
	}) : ''}
	*/
}
export default OrderDetails;
